import { useContext, useMemo } from 'react';
import { FileUploadsStateContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';

export const useFileUploadProgress = (fileIdentifier: string) => {
  const { progress: progressMap } = useContext(FileUploadsStateContext);

  return useMemo(() => {
    return progressMap[fileIdentifier] || 0;
  }, [
    fileIdentifier,
    progressMap,
  ]);
};

export default useFileUploadProgress;